export default __webpack_public_path__ + "static/media/logo_facepay.1a295ef7.svg";